import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Runner } from '@pixi/runner';
import { EventEmitter } from '@pixi/utils';
var SystemManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(SystemManager, _EventEmitter);
  var _super = _createSuper(SystemManager);
  function SystemManager() {
    var _this;
    _classCallCheck(this, SystemManager);
    _this = _super.apply(this, arguments);
    _this.runners = {};
    _this._systemsHash = {};
    return _this;
  }
  _createClass(SystemManager, [{
    key: "setup",
    value: function setup(config) {
      var _config$priority;
      this.addRunners.apply(this, _toConsumableArray(config.runners));
      var priority = ((_config$priority = config.priority) !== null && _config$priority !== void 0 ? _config$priority : []).filter(function (key) {
        return config.systems[key];
      });
      var orderByPriority = [].concat(_toConsumableArray(priority), _toConsumableArray(Object.keys(config.systems).filter(function (key) {
        return !priority.includes(key);
      })));
      var _iterator = _createForOfIteratorHelper(orderByPriority),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          this.addSystem(config.systems[i], i);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "addRunners",
    value: function addRunners() {
      var _this2 = this;
      for (var _len = arguments.length, runnerIds = new Array(_len), _key = 0; _key < _len; _key++) {
        runnerIds[_key] = arguments[_key];
      }
      runnerIds.forEach(function (runnerId) {
        _this2.runners[runnerId] = new Runner(runnerId);
      });
    }
  }, {
    key: "addSystem",
    value: function addSystem(ClassRef, name) {
      var system = new ClassRef(this);
      if (this[name]) {
        throw new Error("Whoops! The name \"".concat(name, "\" is already in use"));
      }
      this[name] = system;
      this._systemsHash[name] = system;
      for (var i in this.runners) {
        this.runners[i].add(system);
      }
      return this;
    }
  }, {
    key: "emitWithCustomOptions",
    value: function emitWithCustomOptions(runner, options) {
      var _this3 = this;
      var systemHashKeys = Object.keys(this._systemsHash);
      runner.items.forEach(function (system) {
        var systemName = systemHashKeys.find(function (systemId) {
          return _this3._systemsHash[systemId] === system;
        });
        system[runner.name](options[systemName]);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      Object.values(this.runners).forEach(function (runner) {
        runner.destroy();
      });
      this._systemsHash = {};
    }
  }]);
  return SystemManager;
}(EventEmitter);
export { SystemManager };